import script from "./WorkflowDetailsIsacaSection.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowDetailsIsacaSection.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowDetailsIsacaSection.vue?vue&type=style&index=0&id=0e0019a1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e0019a1"]])

export default __exports__